import { librario } from './proto/config';

// Type alias for convenience
type CatalogId = librario.config.CatalogId;

// CatalogIDStrings maps protobuf CatalogId enum values to their string representations
// These strings are used in Stremio addon URLs and manifest JSON
export const CatalogIDStrings: Record<CatalogId, string> = {
  [librario.config.CatalogId.CONTINUE_WATCHING]: "continue-watching-mixed",
  [librario.config.CatalogId.LIBRARY_MIXED]: "library-mixed",
  [librario.config.CatalogId.LIBRARY_MOVIE]: "library-movie",
  [librario.config.CatalogId.LIBRARY_SERIES]: "library-series",
  [librario.config.CatalogId.LIBRARY_CHANNEL]: "library-channel",
  [librario.config.CatalogId.LIBRARY_TV]: "library-tv",
};

// Export the CatalogId enum for convenience
export { CatalogId };
export const CatalogIdEnum = librario.config.CatalogId;
